import {VehicleForm as VFKit} from '../VehicleForm';

export function ExteriorColorGroup() {
  return (
    <>
      <VFKit.BodyStyleColorSelect />
      <VFKit.SimpleTextField name="manufacturerColorName" />
      <VFKit.SimpleTextField name="manufacturerColorCode" />
    </>
  );
}
